import type { releveKm as Fr } from '../fr/releveKm';

/** « releveKm » in English — typed on the French: a missing sentence does not compile. */
export const releveKm: typeof Fr = {
  titre: 'Record a mileage reading',
  conserveNonApplique: (saisi: string, precedent: string, u: string) =>
    `Reading kept, but NOT applied: ${saisi} ${u} is lower than the odometer (${precedent} ${u}).`,
  applique: (immat: string, precedent: string, saisi: string, u: string) => `${immat}: ${precedent} → ${saisi} ${u}.`,
  erreur: 'Could not save',
  horsPeriode: 'This is not the reading period',
  periodeOuverte: 'Reading period open',
  seRelevent: 'Odometers are read ',
  du1au3a: 'from the 1',
  er: 'st',
  du1au3b: ' to the 3rd',
  et: ' and ',
  du15au18: 'from the 15th to the 18th',
  chaqueMois: ' of each month.',
  bloque: (jour: number) => ` Today is the ${jour}${jour % 10 === 1 && jour !== 11 ? 'st' : jour % 10 === 2 && jour !== 12 ? 'nd' : jour % 10 === 3 && jour !== 13 ? 'rd' : 'th'}: come back at the next period, or ask a manager, who can record a reading at any time.`,
  ouvert: (jour: number) => ` Today is the ${jour}${jour % 10 === 1 && jour !== 11 ? 'st' : jour % 10 === 2 && jour !== 12 ? 'nd' : jour % 10 === 3 && jour !== 13 ? 'rd' : 'th'}: now is the time.`,
  vehicule: 'Vehicle',
  choisir: '— choose —',
  compteur: 'Odometer reading',
  dernierConnu: (km: string, u: string) => `Last known: ${km} ${u}.`,
  depuis: (ecart: string, u: string) => `+${ecart} ${u} since the last reading.`,
  inferieurTitre: 'This figure is lower than the odometer',
  inferieurA: 'An odometer does not go backwards. The reading will be kept for the record, but the vehicle mileage will ',
  pas: 'not',
  inferieurB: ' be changed. Check what you entered.',
  commentaire: 'Comment',
  commentaireAide: 'Optional — “at refuelling”, “back from the garage”…',
  derniers: 'Latest readings',
  sources: { saisie: 'Direct entry', etat_des_lieux: 'Inspection', entretien: 'Maintenance' } as Record<string, string>,
  annuler: 'Cancel',
  enregistrement: 'Saving…',
  enregistrer: 'Save reading',
};
